import { sectors } from "../MuslimInvest/Sectors";
import { EXPLORER_SEGMENT_OPTIONS } from "../../explorer/explorerSegments";

export const SIGNUP_SEGMENT_OPTIONS = EXPLORER_SEGMENT_OPTIONS;

export const SIGNUP_OBJECTIVES_OPTIONS = [
  { value: "b2b_lead_generation", label: "B2B lead generation" },
  { value: "finding_reliable_b2b_services", label: "Finding reliable B2B services" },
  { value: "getting_mentorship_advice", label: "Getting mentorship/advice" },
  { value: "supporting_muslim_businesses", label: "Supporting Muslim businesses" },
  { value: "finding_investment_opportunities", label: "Finding investment opportunities" },
  { value: "meeting_investors", label: "Meeting investors" },
  {
    value: "meeting_online_connections_offline",
    label: "Meeting online connections offline",
  },
  { value: "learning_more_about_smbf", label: "Learning more about SMBF" },
  { value: "general_networking", label: "General networking" },
  { value: "exploring_partnerships", label: "Exploring partnerships" },
  { value: "other", label: "Other" },
] as const;

/** @deprecated Stage merged into SIGNUP_SEGMENT_OPTIONS; kept for event booking display. */
export const SIGNUP_STAGE_OPTIONS = [
  { value: "Early Stage Entrepreneur", label: "Early Stage Entrepreneur" },
  { value: "Small to Medium Entrepreneur", label: "Small to Medium Entrepreneur" },
  { value: "Established/Executive", label: "Established/Executive" },
] as const;

export const SIGNUP_SECTOR_OPTIONS = [...sectors].sort();

export type SignupProfileFormValues = {
  phoneNumber: string;
  city: string;
  country: string;
  jobTitle: string;
  companyName: string;
  sector: string;
  explorerAttendeeType: string;
  objectivesForAttending: string;
  stageOfBusiness: string;
  sectorsOfInterest: string[];
  photoSharingConsent: boolean;
  termsAttachmentConsent: boolean;
  gdprConsent: boolean;
  marketingConsent: boolean;
};

export const EMPTY_SIGNUP_PROFILE: SignupProfileFormValues = {
  phoneNumber: "",
  city: "",
  country: "",
  jobTitle: "",
  companyName: "",
  sector: "",
  explorerAttendeeType: "",
  objectivesForAttending: "",
  stageOfBusiness: "",
  sectorsOfInterest: [],
  photoSharingConsent: false,
  termsAttachmentConsent: false,
  gdprConsent: false,
  marketingConsent: false,
};
